<template>

  <v-container fluid v-if="users">

    <im-page-title
      title="Utilizatori"
    />

    <im-user-tool
      :query.sync="query"
    />

    <div class="ma-3 mb-0">
      <v-progress-linear
        :indeterminate="querying"
        :color="querying ? 'primary' : 'grey'"
        rounded
      />
    </div>

    <im-user-list
      :users="users"
      :pagination.sync="pagination"
      @edit="goToEdit"
    />

  </v-container>

  <v-container v-else fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate color="primary"/>
    </v-row>
  </v-container>

</template>

<script>

  import profiles_repository from '@/repositories/profile-repository'

  export default {

    components: {
      'im-page-title': () => import('@/components/ThePageTitle'),
      'im-user-tool': ()  => import('@/components/Admin/User/UserToolbar'),
      'im-user-list': ()  => import('@/components/Admin/User/UserList')
    },

    data: () => ({
      users: null,
      query: null,
      querying: false,
      pagination: {size: 32, page: 1}
    }),

    watch: {
      query: {
        handler: 'fetchUsersDebounced',
        immediate: true
      },
      pagination: {
        handler: 'fetchUsers',
        immediate: false
      }
    },

    methods: {

      fetchUsersDebounced: _.debounce(function () {
        this.pagination.page = 1;
        this.fetchUsers()
      }, 300),

      async fetchUsers() {
        try {
          this.querying = true;
          this.user = await profiles_repository.getMyProfile();
          this.users = await profiles_repository.getProfiles(this.query, this.pagination, {user: this.user});
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.querying = false;
        }
      },

      goToEdit(user) {
        this.$router.push(`/admin/users/${user.user_id}`);
      }

    }

  
  }
</script>